module.exports = __webpack_public_path__ + "static/media/hero_image.1d5ba3ff.png";